module.exports = __webpack_public_path__ + "img/ani_running_man.c3c5882.gif";